import React, { Component } from "react"
import isFeatureEnabled from "shared/featureflags/helperFunctions"

import { createOrderByFilterGroup, genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"

import { federalRegions } from "shared/imports/regionConstants"

import {
    createListFilter,
    createNotInListFilter,
    ManuallyChangedInListFilter,
    LegislativeSessionFilter,
    DateListNoFutureFilter,
    StanceFilter,
    StanceLastUserFilter,
} from "shared/search/containers/Filter/Filters"
import { inIssueFilter, notInIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    VoteBillFilter,
    VoteAmendmentFilter,
    VoteChamberFilter,
    VotePersonVotedWayFilter,
    VotePersonDirectionPercentPartyFilter,
    VoteResultFilter,
    VoteTypeFilter,
    VoteIssueFilter,
    VoteDatePickerStartFilter,
    VoteDatePickerEndFilter,
    VoteVoiceVoteFilter,
} from "shared/search/containers/Filter/VoteFilters"

export class VoteReferenceFilterGroup extends Component {
    static defaultProps = {
        filters: [VoteBillFilter, VoteAmendmentFilter],
        uniqueFilterGroupId: "voteReferenceFilterGroup",
        displayLabel: "Referencing",
        helpText: "Filter votes by association with a specific bill or amendment.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteReferenceInBillProfileFilterGroup extends Component {
    static defaultProps = {
        filters: [VoteAmendmentFilter],
        uniqueFilterGroupId: "voteReferenceFilterGroup",
        displayLabel: "Referencing",
        helpText: "Filter votes by association with a specific amendment.",
        regions: federalRegions,
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteSessionFilterGroup extends Component {
    static defaultProps = {
        filters: [LegislativeSessionFilter],
        uniqueFilterGroupId: "voteSessionFilterGroup",
        displayLabel: "Session",
        helpText: "Filter for votes from a particular session.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteChamberFilterGroup extends Component {
    static defaultProps = {
        filters: [VoteChamberFilter],
        uniqueFilterGroupId: "voteChamberFilterGroup",
        displayLabel: "Chamber",
        helpText: "Filter for votes from a particular chamber.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteMultiFilterGroup extends Component {
    static defaultProps = {
        filters: [VotePersonVotedWayFilter],
        uniqueFilterGroupId: "voteMultiFilterGroup",
        displayLabel: "Voters",
        helpText:
            "Filter for votes where an individual voter voted a certain way " +
            "or a group of voters voted a particular way. First, choose a voter or group " +
            "of voters. Next, choose which way the voter(s) should have voted. Finally, if " +
            "you'd like to show votes where any of the voters voted the desired way, choose " +
            "'ANY'. If you'd like to show only votes where all of the voters voted the desired " +
            "way, choose 'ALL'.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteCompareFilterGroup extends Component {
    static defaultProps = {
        filters: [VotePersonDirectionPercentPartyFilter],
        uniqueFilterGroupId: "voteCompareFilterGroup",
        displayLabel: "Compare",
        helpText:
            "Filter for votes where an individual legislator voted either with " +
            "or against a certain percentage of a party or chamber.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteResultFilterGroup extends Component {
    static defaultProps = {
        filters: [VoteResultFilter],
        uniqueFilterGroupId: "voteResultFilterGroup",
        displayLabel: "Result",
        helpText: "Filter for votes that had a particular overall result — either " + "successful or not.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteCategoryFilterGroup extends Component {
    static defaultProps = {
        filters: [VoteChamberFilter, VoteTypeFilter, VoteVoiceVoteFilter],
        uniqueFilterGroupId: "voteCategoryFilterGroup",
        displayLabel: "Vote Type",
        helpText: "Filter votes by type of vote, whether for legislation, procedural " + "changes, or approvals.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteIssueFilterGroup extends Component {
    static defaultProps = {
        filters: [VoteIssueFilter],
        uniqueFilterGroupId: "voteIssueFilterGroup",
        displayLabel: "Legislative Issues",
        helpText:
            "Filter for votes related to a particular issue as determined by " +
            "their related bill. At the federal level, we use issue areas as determined " +
            "by the Congressional Research Service. At the state level, we use machine " +
            "learning to assign multiple issue areas to each bill.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteDateRangeFilterGroup extends Component {
    static defaultProps = {
        filters: [DateListNoFutureFilter, VoteDatePickerStartFilter, VoteDatePickerEndFilter],
        uniqueFilterGroupId: "voteDateRangeFilterGroup",
        displayLabel: "Date",
        helpText: "Filter for votes from a particular time period or date range.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteListFilterGroup extends Component {
    static defaultProps = {
        filters: [
            createListFilter(DjangIO.app.models.QuorumDataType.vote.value),
            createNotInListFilter(DjangIO.app.models.QuorumDataType.vote.value),
            ManuallyChangedInListFilter,
        ],
        uniqueFilterGroupId: "voteListFilterGroup",
        displayLabel: "Lists",
        helpText:
            `Filter for votes that you have saved to ${isFeatureEnabled("issuesManagement") ? "issues" : "Projects"}` +
            "or exclude saved votes from search results.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteStanceFilterGroup extends Component {
    static defaultProps = {
        filters: [StanceFilter, StanceLastUserFilter],
        uniqueFilterGroupId: "voteStanceFilterGroup",
        displayLabel: "Stance",
        helpText: "Filter by votes your organization has indicated as supporting or opposing.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class VoteProjectFilterGroup extends Component {
    static defaultProps = {
        filters: [inIssueFilter, notInIssueFilter],
        uniqueFilterGroupId: "voreProjectFilterGroup",
        displayLabel: "Issues",
        helpText: "Filter votes by tagged Issues.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const VoteOrderByFilterGroup = createOrderByFilterGroup({
    // uniqueFilterId = "voteOrderBy"
    quorumDataType: DjangIO.app.models.QuorumDataType.vote.value,
})
